var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPrint = function SvgPrint(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-24": 21,
    viewBox: "0 0 20.5 18.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.89 3.08v-.79A2.3 2.3 0 0 1 6.18 0h8.22a2.3 2.3 0 0 1 2.29 2.29v.79h1.01a2.81 2.81 0 0 1 2.8 2.8v7.19a2.29 2.29 0 0 1-2.21 2.28h-1.6v1.06a2.3 2.3 0 0 1-2.29 2.29H6.18a2.3 2.3 0 0 1-2.29-2.29v-1.05h-1.6A2.29 2.29 0 0 1 0 13.07V5.88a2.81 2.81 0 0 1 2.8-2.8zm11.3 0h-9.8v-.79a.79.79 0 0 1 .79-.79h8.22a.79.79 0 0 1 .79.79zm0 11.52v-2.81a.79.79 0 0 0-.79-.79H6.18a.79.79 0 0 0-.79.79v4.62a.79.79 0 0 0 .79.79h8.22a.79.79 0 0 0 .79-.79V14.6m3.1-.75h-1.6v-2.06A2.3 2.3 0 0 0 14.4 9.5H6.18a2.3 2.3 0 0 0-2.29 2.29v2.07H2.33a.79.79 0 0 1-.79-.79V5.88a1.3 1.3 0 0 1 1.3-1.3h14.94a1.3 1.3 0 0 1 1.3 1.3v7.18a.79.79 0 0 1-.79.79",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPrint);
export default ForwardRef;